import type { ThemeOptions } from '@mui/material';

import { palette } from './palette';
import { typography } from './typography';

declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    infoButton: true;
  }
}

export const buttonComponent = {
  styleOverrides: {
    sizeLarge: typography.buttonLarge,
    sizeMedium: typography.buttonMedium,
    sizeSmall: typography.buttonSmall,

    // For some reason these colors are not applied by default
    containedPrimary: {
      backgroundColor: palette.primary.main,
      ':hover': {
        backgroundColor: palette.primary.dark,
      },
    },
    containedSecondary: {
      ':hover': {
        backgroundColor: palette.secondary.light,
      },
    },
    outlinedSecondary: {
      borderColor: palette.secondary.dark,
      color: palette.secondary.contrastText,
      ':hover': {
        borderColor: palette.secondary.dark,
        backgroundColor: palette.action.hover,
      },
    },
    textSecondary: {
      color: palette.secondary.contrastText,
      ':hover': {
        backgroundColor: palette.action.hover,
      },
    },
  },
} as const satisfies NonNullable<ThemeOptions['components']>['MuiButton'];
